// Charakter-Daten aus den offiziellen Character Sheets 
// Portraits liegen unter /characters/<slug>.jpg (Public-Folder) 
export const characters = [ 
  { 
    slug: "zixue", 
    name: "Zīxuě", 
    chinese: "姿雪", 
    kingdom: "Báisǐ Mén", 
    kingdomColor: "#E8DDC8", 
    age: "21", 
    power: { 
      de: "Unbekannt", 
      en: "Unknown" 
    }, 
    eye: { 
      de: "Silber", 
      en: "Silver" 
    }, 
    energy: 12, 
    energyMax: 10, 
    specialty: {
      de: "Politische Strategie",
      en: "Political strategy"
    },
    weakness: {
      de: "Familie",
      en: "Family"
    },
    rank: {
      de: "Zukünftige Kaiserin Ruihuas",
      en: "Future Empress of Ruihua"
    },
    secretWish: {
      de: "Eine sorgenlose Schwangerschaft",
      en: "A carefree pregnancy"
    },
    quote: { 
      de: "Anmutiger Schnee", 
      en: "Graceful Snow." 
    }, 
    song: "I-DLE — Dahlia", 
    tag: "UW", 
    accent: "#E8DDC8"
  }, 
  { 
    slug: "zhenyang", 
    name: "Zhènyáng", 
    chinese: "振阳", 
    kingdom: "Ruìhuá", 
    kingdomColor: "#C9A227", 
    age: "42", 
    power: { 
      de: "Unbekannt", 
      en: "Unknown" 
    }, 
    eye: { 
      de: "Gold", 
      en: "Gold" 
    }, 
    energy: 11, 
    energyMax: 10, 
    specialty: {
      de: "Politische Durchsetzungskraft",
      en: "Political assertiveness"
    },
    weakness: {
      de: "Zīxuě",
      en: "Zīxuě"
    },
    rank: {
      de: "Kaiser Ruihuas",
      en: "Emperor of Ruihua"
    },
    secretWish: {
      de: "Eine glückliche Familie",
      en: "A happy family"
    },
    quote: { 
      de: "Erhebende Sonne", 
      en: "Rising Sun" 
    }, 
    song: "Ghost — Mary on a Cross", 
    tag: "OW", 
    accent: "#C9A227"
  }, 
  { 
    slug: "luhua", 
    name: "Lùhuá", 
    chinese: "露华", 
    kingdom: "Tiántài", 
    kingdomColor: "#9FB5A4", 
    age: "20", 
    power: { 
      de: "Schweben", 
      en: "Levitation" 
    }, 
    eye: { 
      de: "Gelb", 
      en: "Yellow" 
    }, 
    energy: 8, 
    energyMax: 10, 
    specialty: {
      de: "Wirtschaftliche Mittel",
      en: "Economic resources"
    },
    weakness: {
      de: "Kontrollverlust",
      en: "Loss of control"
    },
    rank: {
      de: "Kind des Königspaares von Tiántài",
      en: "Child of the royal couple of Tiántài"
    },
    secretWish: {
      de: "Freiheit",
      en: "Freedom"
    },
    quote: { 
      de: "Tautropfenblüte", 
      en: "Dewdrop Blossom" 
    }, 
    song: "Sabrina Carpenter — Tears", 
    tag: "UW", 
    accent: "#9FB5A4"
  }, 
  { 
    slug: "chiyan", 
    name: "Chìyàn", 
    chinese: "赤焰", 
    kingdom: "Wūyúnfēng", 
    kingdomColor: "#B01218", 
    age: "31", 
    power: { 
      de: "Reines Feuer", 
      en: "Pure Fire" 
    }, 
    eye: { 
      de: "Rot", 
      en: "Red" 
    }, 
    energy: 9, 
    energyMax: 10, 
    specialty: {
      de: "Schwert und Kampfkunst",
      en: "Swordsmanship and martial arts"
    },
    weakness: {
      de: "Verbundenheit zu Unterwürfigen",
      en: "Attachment to subordinates"
    },
    rank: {
      de: "Kind des Königspaares von Wūyúnfēng",
      en: "Child of the royal couple of Wūyúnfēng"
    },
    secretWish: {
      de: "Verantwortungslosigkeit",
      en: "Freedom from responsibility"
    },
    quote: { 
      de: "Scharlachrote Flamme", 
      en: "Scarlet Flame" 
    }, 
    song: "Sam Tinnesz, Yacht Money — Play with Fire", 
    tag: "OW", 
    accent: "#B01218"
  }, 
  { 
    slug: "bitgyeol", 
    name: "Bitgyeol", 
    chinese: "빛결", 
    kingdom: "Hwawon", 
    kingdomColor: "#7AB6FF", 
    age: "23", 
    power: { 
      de: "Licht", 
      en: "Light" 
    }, 
    eye: { 
      de: "Blau", 
      en: "Blue" 
    }, 
    energy: 2, 
    energyMax: 10, 
    specialty: {
      de: "Menschenkenntnis",
      en: "Knowledge of human nature"
    },
    weakness: {
      de: "Unreiner Status",
      en: "Impure status"
    },
    rank: {
      de: "Bastardkind",
      en: "Bastard child"
    },
    secretWish: {
      de: "Komplette Freiheit vom Stand",
      en: "Complete freedom from status"
    },
    quote: { 
      de: "Lichtmuster", 
      en: "Light Patterns" 
    }, 
    song: "Sofia Isella — The Doll People", 
    tag: "UW", 
    accent: "#7AB6FF"
  }, 
  { 
    slug: "shuilan", 
    name: "Shuǐlán", 
    chinese: "水澜", 
    kingdom: "Hogwan", 
    kingdomColor: "#2E78A8", 
    age: "26", 
    power: { 
      de: "Reines Wasser", 
      en: "Pure Water" 
    }, 
    eye: { 
      de: "Rot", 
      en: "Red" 
    }, 
    energy: 9, 
    energyMax: 10, 
    specialty: {
      de: "Konfliktbewältigung",
      en: "Conflict resolution"
    },
    weakness: {
      de: "Mangelndes Selbstbewusstsein",
      en: "Lack of self-confidence"
    },
    rank: {
      de: "Kind vom Königspaar von Hogwan",
      en: "Child of the royal couple of Hogwan"
    },
    secretWish: {
      de: "Gesunde Familie",
      en: "Healthy family"
    },
    quote: { 
      de: "Sanfte Wasserwelle", 
      en: "Gentle Water Wave" 
    }, 
    song: "Billie Eilish — everything i wanted", 
    tag: "OW", 
    accent: "#2E78A8"
  }, 
  { 
    slug: "lanzi", 
    name: "Lánzǐ", 
    chinese: "兰紫", 
    kingdom: "Ānqiáng", 
    kingdomColor: "#9240be", 
    age: "17", 
    power: { 
      de: "Pflanzen", 
      en: "Plants" 
    }, 
    eye: { 
      de: "Grün", 
      en: "Green" 
    }, 
    energy: 5, 
    energyMax: 10, 
    specialty: {
      de: "Gute Kontakte",
      en: "Good connections"
    },
    weakness: {
      de: "Bekommt schnell Angst",
      en: "Gets scared easily"
    },
    rank: {
      de: "Kind vom Königspaar von Ānqiáng",
      en: "Child of the royal couple of Ānqiáng"
    },
    secretWish: {
      de: "Wahre Liebe finden",
      en: "To find true love"
    },
    quote: { 
      de: "Fliederfarbene Orchidee", 
      en: "Lavender Orchid" 
    }, 
    song: "IU — Palette", 
    tag: "UW", 
    accent: "#9240be"
  }, 
  { 
    slug: "chengxi", 
    name: "Chéngxī", 
    chinese: "诚曦", 
    kingdom: "Fēnggǎng", 
    accent: "#0F8B6D", 
    kingdomColor: "#0F8B6D", 
    age: "26", 
    power: { 
      de: "Blitze", 
      en: "Lightning" 
    }, 
    eye: { 
      de: "Gelb", 
      en: "Yellow" 
    }, 
    energy: 7, 
    energyMax: 10, 
    specialty: {
      de: "Kampfkunst",
      en: "Martial arts"
    },
    weakness: {
      de: "Waffenbeherrschung",
      en: "Weapon mastery"
    },
    rank: {
      de: "Kind vom Königspaar von Fēnggǎng",
      en: "Child of the royal couple of Fēnggǎng"
    },
    secretWish: {
      de: "Weniger Verantwortung",
      en: "Less responsibility"
    },
    quote: { 
      de: "Aufrichtige Morgensonne", 
      en: "Upright Morning Sun" 
    }, 
    song: "G-Dragon — Too Bad", 
    tag: "OW"
  }, 
  { 
    slug: "xiyue", 
    name: "Xǐyuè", 
    chinese: "喜悦", 
    kingdom: "Sanghang", 
    kingdomColor: "#D4A4C5", 
    age: "24", 
    power: { 
      de: "Eis", 
      en: "Ice" 
    }, 
    eye: { 
      de: "Braun", 
      en: "Brown" 
    }, 
    energy: 4, 
    energyMax: 10, 
    specialty: {
      de: "Wissen über abgelegene Inselstaaten",
      en: "Knowledge of remote island nations"
    },
    weakness: {
      de: "Schwache Bindung zum Elyra",
      en: "Weak connection to Elyra"
    },
    rank: {
      de: "Kind vom Königspaar von Sanghang",
      en: "Child of the royal couple of Sanghang"
    },
    secretWish: {
      de: "Mehr politische Sicherheit",
      en: "More political security"
    },
    quote: { 
      de: "Tiefe Freude", 
      en: "Deep Joy" 
    }, 
    song: "Twice — Likey", 
    tag: "UW", 
    accent: "#D4A4C5"
  }, 
  { 
    slug: "qiangzhong", 
    name: "Qiángzhōng", 
    chinese: "强忠", 
    kingdom: "Gāobì", 
    kingdomColor: "#7A4A2A", 
    age: "46", 
    power: { 
      de: "Elyra", 
      en: "Elyra" 
    }, 
    eye: { 
      de: "Braun", 
      en: "Brown" 
    }, 
    energy: 2, 
    energyMax: 10, 
    specialty: {
      de: "Kampf- und Waffenkunst",
      en: "Combat and weaponry arts"
    },
    weakness: {
      de: "Stadtmeisterin",
      en: "City master"
    },
    rank: {
      de: "Leibwächter des Kaisers",
      en: "Bodyguard of the Emperor"
    },
    secretWish: {
      de: "",
      en: ""
    },
    quote: { 
      de: "Starke Loyalität", 
      en: "Strong Loyalty" 
    }, 
    song: "DPR — Do or Die", 
    tag: "OW", 
    accent: "#7A4A2A"
  }, 
  { 
    slug: "jinwoo", 
    name: "Jinwoo", 
    chinese: "진우", 
    kingdom: "Namjiwon", 
    kingdomColor: "#5A7F8C", 
    age: "27", 
    power: { 
      de: "Elyra", 
      en: "Elyra" 
    }, 
    eye: { 
      de: "Braun", 
      en: "Brown" 
    }, 
    energy: 1, 
    energyMax: 10, 
    specialty: {
      de: "Manipulation",
      en: "Manipulation"
    },
    weakness: {
      de: "Flatterhaft",
      en: "Fickle"
    },
    rank: {
      de: "Adelige Zofe der Kaiserin",
      en: "Noble maid of the Empress"
    },
    secretWish: {
      de: "Wahre Liebe finden",
      en: "To find true love"
    },
    quote: { 
      de: "Kostbares Universum", 
      en: "Precious Universe" 
    }, 
    song: "JVKE — golden hour", 
    tag: "UW", 
    accent: "#5A7F8C"
  }, 
  { 
    slug: "jaehyun", 
    name: "Jaehyun", 
    chinese: "재현", 
    kingdom: "Sorestowe", 
    kingdomColor: "#6B6F8C", 
    age: "32", 
    power: { 
      de: "Keine", 
      en: "None" 
    }, 
    eye: { 
      de: "Braun", 
      en: "Brown" 
    }, 
    energy: 0, 
    energyMax: 10, 
    specialty: {
      de: "Medizin",
      en: "Medicine"
    },
    weakness: {
      de: "Vergangenheit",
      en: "Past"
    },
    rank: {
      de: "Kaiserlicher Hofarzt",
      en: "Imperial court physician"
    },
    secretWish: {
      de: "Erwiderte Liebe",
      en: "Reciprocated love"
    },
    quote: { 
      de: "Meine Familie und Freunde.", 
      en: "My family and friends." 
    }, 
    song: "I-DLE — Eyes Roll", 
    tag: "OW", 
    accent: "#6B6F8C"
  }
]; 

export const findCharacter = (slug) => characters.find((c) => c.slug === slug);